import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row q-no-gutters" }
const _hoisted_2 = { class: "dropdown-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyAutoComplete = _resolveComponent("CompanyAutoComplete")!
  const _component_RouteAutocompleteComponent = _resolveComponent("RouteAutocompleteComponent")!
  const _component_VehicleAutocompleteComponent = _resolveComponent("VehicleAutocompleteComponent")!
  const _component_AdministratorAutocompleteComponent = _resolveComponent("AdministratorAutocompleteComponent")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCompanyVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['col-12', _ctx.cityShow ? 'col-sm-3' : 'col-sm-6', 'q-pa-xs'])
        }, [
          _createVNode(_component_CompanyAutoComplete, {
            company_id: _ctx.companyComputed,
            onCompany_selected: _ctx.companySelected,
            clear: _ctx.clearCompanyAutocomplete,
            onClear: _ctx.onClearCompany
          }, null, 8, ["company_id", "onCompany_selected", "clear", "onClear"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isRouteVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(['col-12', _ctx.cityShow ? 'col-sm-3' : 'col-sm-6', 'q-pa-xs'])
        }, [
          _createVNode(_component_RouteAutocompleteComponent, {
            route_id: _ctx.routeComputed,
            company_id: _ctx.companyComputed,
            onRoute_selected: _ctx.routeSelected,
            clear: _ctx.clearRouteAutocomplete,
            onClear: _ctx.onClearRoute
          }, null, 8, ["route_id", "company_id", "onRoute_selected", "clear", "onClear"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isVehicleVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(['col-12', _ctx.cityShow ? 'col-sm-3' : 'col-sm-2', 'q-pa-xs'])
        }, [
          _createVNode(_component_VehicleAutocompleteComponent, {
            vehicle_id: _ctx.vehicleComputed,
            company_id: _ctx.companyComputed,
            onVehicle_selected: _ctx.vehicleSelected,
            clear: _ctx.clearVehicleAutocomplete,
            onClear: _ctx.onClearVehicle
          }, null, 8, ["vehicle_id", "company_id", "onVehicle_selected", "clear", "onClear"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isAdministratorVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(['col-12', _ctx.cityShow ? 'col-sm-3' : 'col-sm-2', 'q-pa-xs'])
        }, [
          _createVNode(_component_AdministratorAutocompleteComponent, {
            administrator_id: _ctx.administratorComputed,
            onAdministrator_selected: _ctx.administratorSelected,
            clear: _ctx.clearAdministratorAutocomplete,
            label: _ctx.labelAdministrator,
            onClear: _ctx.onClearAdministrator,
            company_id: _ctx.companyComputed
          }, null, 8, ["administrator_id", "onAdministrator_selected", "clear", "label", "onClear", "company_id"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isActiveVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(['col-12', _ctx.cityShow ? 'col-sm-2' : 'col-sm-2', 'q-pa-sm'])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn_dropdown, {
              color: "primary",
              label: "Activo / Inactivo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, { tag: "label" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, {
                          side: "",
                          top: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_checkbox, {
                              modelValue: _ctx.active,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Activos")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_ripple]
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, { tag: "label" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, {
                          side: "",
                          top: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_checkbox, {
                              modelValue: _ctx.inactive,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inactive) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Inactivos")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_ripple]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}